<template>
    <div class="guestlist-card" @click="$emit('click')">
        <p><b>Guest List</b></p>
        <p>{{ count }} guests</p>
    </div>
</template>

<script>
export default {
    name: 'GuestList',
    props: {
        count: {
            type: Number,
            default: undefined,
        },
    },
}
</script>

<style scoped lang="sass">
.guestlist-card
  background: $neutral-white
  box-shadow: $box-mois
  display: flex
  justify-content: space-between
  border-radius: 10px
  align-items: center
  margin-bottom: $l
  cursor: pointer
  padding: $m
</style>
